import React, {useState, useRef, useContext} from "react";
import {
  apollo_useStyles,
  getDialogStyle,
  getValueCautionStyle,
  getValueLineStyle,
  options_extension_manual,
  options_manualType,
  options_mimetype_manual,
  valueToOption,
} from "../../atom/Apollo_styles";
import {apollo_manuals_path} from "../../atom/Apollo_links";
import {ApolloMessage} from "../../atom/Apollo_Mesasge"
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../atom/Apollo_ApiRequest3";
// メッセージ定義
import {
  GetMessage,
  UI_MANUAL_UPLOAD,
} from "../../atom/Apollo_MesasgeDefinition";

// MODAL
import Card from "@material-ui/core/Card/Card";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import {LogRecord, Manual} from "../../pages/MANUAL/ManualModel";
import {Backdrop, Button} from "@material-ui/core";
import {ApolloBasicTwoLineLabel} from "../../molecule/Apollo_BaseItem";
import Typography from "@material-ui/core/Typography";
import ApolloFileSelect from "../../atom/Apollo_FileSelect";
import {
  ApolloEventRecord, createLogDate,
  createUserLogItemListByOption,
  createUserLogItemListFromString,
  ItemList, LogData
} from "../../atom/Apollo_EventRecord";
import {ApolloContext} from "../../atom/Apollo_Context";
import moment from "moment";
import {Bars} from "react-loader-spinner";

type ManualProps = {
  manual: Manual,
  setOpen: any,
  listReloadFunc?: any,
}

// マニュアルファイルアップロード
const ApolloManualUploadModal = ({manual, setOpen, listReloadFunc}: ManualProps) => {
  const classes = apollo_useStyles();
  const {state} = useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const beforeEditRecord = useRef<LogRecord | null>(null);
  const [binary, setBinary] = useState("");
  const [files, setFiles] = useState("");
  const [progress, setProgress] = useState(false);
  const processing = useRef(false);

  const inputProps = {
    manualType: {
      id: "manualType",
      label: "カテゴリ",
      options: options_manualType,
    },
    name: {
      id: "name",
      label: "ファイル名",
    },
    mimeType: {
      id: "mimeType",
      label: "拡張子",
      options: options_mimetype_manual,
    },
    file: {
      id: "file",
      label: "アップロードファイル",
      accept: valueToOption(manual.mimeType, options_mimetype_manual)?.label,
      maxSize: 20,
      isMultiple: false,
    }
  }

  const onSubmit = async () => {
    if (processing.current) return;
    processing.current = true;
    setProgress(processing.current);
    let isSuccess = false;

    if (!files || files.length === 0) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルを選択してください"
        }
      });
      processing.current = false;
      setProgress(processing.current);
      return;
    }

    // @ts-ignore
    const file: File = files[0];

    beforeEditRecord.current = {
      manualType: manual.manualType,
      name: "",
      mimeType: manual.mimeType,
    }

    const params = new FormData();
    params.append(`file`, file);
    params.append('manualType', manual.manualType.toString());

    const executeLog = createUserLog(
      state,
      "",
      "マニュアル",
      "更新",
      "マニュアル管理",
      beforeEditRecord.current,
      {
        manualType: manual.manualType,
        name: file?.name ? file?.name : "",
        mimeType: manual.mimeType,
      },
    );
    executeLog.targetID = manual.manualType.toString();
    executeLog.targetName = valueToOption(manual.manualType, options_manualType).label;
    ApolloEventRecord({...executeLog, logType: "execute"});

    const url = apollo_manuals_path;
    ApolloAxios.put(url, params, {
      timeout: 600000,
    }).then(response => {
      const res: ApiResponse = response.data;
      if (!isSuccessApi(res.resultCode)) {
        return Promise.reject({
          open: true,
          type: getResultType(res.resultCode),
          errmsg: res?.message ? res.message : GetMessage("0", UI_MANUAL_UPLOAD, "E", "0"),
        });
      }

      isSuccess = true;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: getResultType(res.resultCode),
          message: GetMessage("0", UI_MANUAL_UPLOAD, "I", "0"),
        }
      });

    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executeLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        result: isSuccess ? "成功" : "失敗",
      };
      ApolloEventRecord({...resultLog, logType: "result"});
      processing.current = false;
      setProgress(processing.current);
      if (isSuccess) listReloadFunc && listReloadFunc();
    });
  };

  // モーダルクローズハンドラ
  const handleModalClose = () => {
    setOpen(false);
  };

  // 画面表示
  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop2} open={progress}>
        <Bars color="#00BFFF" height={80} width={80}/>
      </Backdrop>
      < Card style={getDialogStyle()}>
        <Grid item xs={12}>
          <ApolloBasicTwoLineLabel label={inputProps.manualType.label}
                                   value={valueToOption(manual.manualType, options_manualType)?.label}
                                   valueStyle={getValueLineStyle()}/>
        </Grid>
        <Grid item xs={12}>
          <ApolloBasicTwoLineLabel label={inputProps.name.label} value={manual.name} valueStyle={getValueLineStyle()}/>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom component="div">
            {inputProps.file.label}
          </Typography>
          <Typography variant="body2" gutterBottom component="div" color="textSecondary">
            【サイズ】最大20MB<br/>
            【ファイル形式】{valueToOption(manual.mimeType, options_extension_manual)?.label}<br/>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ApolloFileSelect
            setBinary={setBinary}
            setFiles={setFiles}
            accept={inputProps.file.accept}
            maxSize={inputProps.file.maxSize}
            isMultiple={inputProps.file.isMultiple}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography color="secondary" style={getValueCautionStyle()}>アップロードされたファイルはリネームされます。</Typography>
        </Grid>
        <CardActions className={classes.cardaction}>
          <Button
            type="submit"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            variant="contained"
            disabled={files === "" || processing.current}
          >
            アップロード
          </Button>
          <Button
            variant="contained"
            color="inherit"
            onClick={handleModalClose}
            className={classes.button}
            disabled={processing.current}
          >
            キャンセル
          </Button>
        </CardActions>
      </Card>
    </React.Fragment>
  );
}

export default ApolloManualUploadModal;


const createUserLog = (
  apolloContex: any,
  menu: string,
  category: string,
  actionType: string,
  displayName: string,
  beforeInfo: LogRecord | null,
  afterInfo: LogRecord,
) => {
  const items: ItemList[] = [
    createUserLogItemListByOption("カテゴリ", "manualType", beforeInfo, afterInfo, options_manualType),
    createUserLogItemListFromString("アップロードファイルファイル", "name", beforeInfo, afterInfo,),
    createUserLogItemListByOption("MIME種別", "mimeType", beforeInfo, afterInfo, options_mimetype_manual),
  ];

  const retObj = createLogDate(
    apolloContex,
    menu,
    category,
    actionType,
    displayName,
    items,
  );

  return retObj
}
